// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2qaB4","header":"PatientQuestionnaire_header__382-1","info":"PatientQuestionnaire_info__2Ay98"};